import React from "react";
import { Link } from "react-router-dom";

const NavigationLink = ({
  href,
  linkImage,
  label,
  isMenuOpen,
  closeBurgerMenu,
}) => {
  return (
    <Link
      onClick={() => {
        if (isMenuOpen) {
          closeBurgerMenu();
        }
      }}
      className="flex h-[45px] w-[92px] items-center gap-2 px-4 py-3 w-full border border-transparent
       md:w-fit rounded-lg hover:border transition-all duration-300 hover:border-deepBlue dark:hover:!bg-[#3C3A66] 
       active:bg-lightBlue bg-white dark:bg-navyAccent"
      to={href}
    >
      <div className="w-4 h-4 flex items-center justify-center">
        {linkImage}
      </div>
      <p className="text-sm text-black leading-[21px] dark:text-white capitalize">
        {label}
      </p>
    </Link>
  );
};

export default NavigationLink;
